import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import Lounge from "../views/lounge/Lounge.vue";
import MainApp from "../views/MainApp.vue";
import { Device } from "@capacitor/device";
const routes = [{
        path: "/authenticate",
        name: "Authenticate",
        component: () =>
            import ("../views/auth/Authenticate.vue"),
    },
    {
        path: "/intro",
        name: "Intro",
        component: () =>
            import ("../views/Intro.vue"),
    },
    {
        path: "/",
        name: "Lounge",
        component: Lounge,
    },
    {
        path: "/app",
        name: "MainApp",
        component: MainApp,
    },
    {
        path: "/menu/type/:category",
        name: "MenuByType",
        props: true,
        component: () =>
            import ("../views/menu/MenuByType.vue"),
    },
    {
        path: "/menu_search",
        name: "MenuSearch",
        meta: { transition: "none" },
        component: () =>
            import ("../views/menu/menusearch/MenuSearch.vue"),
    },
    {
        path: "/menu/details/:menuID",
        name: "MenuDescription",
        props: true,
        component: () =>
            import ("../views/menu/MenuDescription.vue"),
    },
    {
        path: "/checkout/",
        name: "Checkout",
        props: true,
        component: () =>
            import ("../views/checkout/Checkout.vue"),
    },
    {
        path: "/print_order_receipt/:orderReference",
        name: "PrintOrderReceipt",
        props: true,
        component: () =>
            import ("../views/orders/PrintOrderReceipt.vue"),
    },
    {
        path: "/orders",
        name: "Orders",
        component: () =>
            import ("../views/orders/Orders.vue"),
    },
    {
        path: "/orders/track",
        name: "TrackOrder",
        component: () =>
            import ("../views/orders/TrackOrder.vue"),
    },
    {
        path: "/orders/details/:orderReference",
        name: "OrderDetails",
        props: true,
        component: () =>
            import ("../views/orders/OrderDetails.vue"),
    },
    {
        path: "/order_placed/:orderReference",
        name: "OrderPlaced",
        props: true,
        component: () =>
            import ("../views/orders/OrderPlaced.vue"),
    },
    {
        path: "/edit_profile",
        name: "EditProfile",
        component: () =>
            import ("../views/more/profile/EditProfile.vue"),
    },
    {
        path: "/favourites",
        name: "Favourites",
        component: () =>
            import ("../views/more/favourites/Favourites.vue"),
    },
    {
        path: "/feedback",
        name: "Feedback",
        component: () =>
            import ("../views/more/feedback/Feedback.vue"),
    },
    {
        path: "/about_us",
        name: "AboutUs",
        component: () =>
            import ("../views/more/AboutUs.vue"),
    },
    {
        path: "/faq",
        name: "FAQ",
        component: () =>
            import ("../views/more/FAQ.vue"),
    },
    {
        path: "/privacy_policy",
        name: "PrivacyPolicy",
        component: () =>
            import ("../views/more/PrivacyPolicy.vue"),
    },
    {
        path: "/terms_of_service",
        name: "TermsOfService",
        component: () =>
            import ("../views/more/TermsOfService.vue"),
    },
    {
        path: "/:pathMatch(.*)*",
        name: "PageNotFound",
        component: Lounge,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});
router.beforeEach((to, from, next) => {
    if (!localStorage.appLaunched) {
        Device.getInfo().then((infoObject) => {
            if (infoObject.platform == "web") {
                next()
            } else {
                next({ name: "Intro" });
            }
        }).catch(() => {
            next()
        }).finally(() => {
            localStorage.appLaunched = true;
        })
    } else {
        if (to.name == "Checkout") {
            if (!localStorage.checkout || !from.name) {
                next({ name: "MainApp" });
            } else if (!Object.keys(store.state.user).length > 0) {
                next({ name: "Authenticate" });
            } else {
                next();
            }
        } else {
            next();
        }
    }
});

export default router;